import Backbone from 'backbone';

import {DigestTabState} from 'analyses/DigestTabState';
import Layout from 'analyses/VirtualDigestLayout';
import {Sequence} from 'components/Sequence';
import DefaultLadders from 'data/Ladders';
import {PolymerTabState, PolymerTabStateAttributes} from 'molbio/tabstates/PolymerTabState';
import {TabStateDefaults, PREFERENCE_KEY_IGNORE} from 'Navigation';

export interface Ladder {
  // ID is a number for user-defined ladders and string for pre-defined ladders.
  id: string | number;
  name: string;
  bands: Array<number>;
}

interface VirtualDigestTabStateAttributes extends PolymerTabStateAttributes<Sequence> {
  ladderId: string;
  digests: Backbone.Collection<DigestTabState>;
  layout: typeof Layout;
  ladders: Array<Ladder>;
}

interface VirtualDigestTabState {
  get<K extends keyof VirtualDigestTabStateAttributes>(key: K): VirtualDigestTabStateAttributes[K];
  set<K extends keyof VirtualDigestTabStateAttributes>(
    attributeName: K,
    value: VirtualDigestTabStateAttributes[K],
    options?: Backbone.ModelSetOptions
  ): VirtualDigestTabState;
  set(
    obj: Partial<VirtualDigestTabStateAttributes>,
    options?: VirtualDigestTabStateAttributes
  ): VirtualDigestTabState;
}

class VirtualDigestTabState extends PolymerTabState<Sequence> {
  override defaults(): TabStateDefaults & Partial<VirtualDigestTabStateAttributes> {
    return {
      ...super.defaults(),
      active: false,
      closeable: false,
      ladderId: 'life-1kbplus',
      digests: new Backbone.Collection(),
      title: 'Virtual Digest',
      layout: Layout,
      ladders: DefaultLadders.slice(),
      preferenceKey: PREFERENCE_KEY_IGNORE,
    };
  }

  ladders(): Array<Ladder> {
    return this.get('ladders');
  }
}

export default VirtualDigestTabState;
